import { BadgeVariant } from 'components/Badge';
import { ClaimStatus, ClaimStatusInternal } from 'domains/billing';

export const FINAL_CLAIM_STATES: ClaimStatus[] = ['finalized_denied', 'finalized_paid'];

export const isClaimFinalized = (status: ClaimStatus) => FINAL_CLAIM_STATES.includes(status);

export const PAID_PATIENT_PAYMENT_STATES = ['paid', 'completed', 'succeeded'];

// Candid's documentation is not clear about the patient payment status case (upper or lower)
export const isPatientPaymentPaid = (status: string) => PAID_PATIENT_PAYMENT_STATES.includes(status.toLowerCase());

/** Returns the status to be shown to the user */
export const getClaimShownStatus = (status: ClaimStatus, realBalance: number): ClaimStatusInternal => {
  if (isClaimFinalized(status)) {
    if (realBalance <= 0) {
      return 'paid';
    }
    return 'ready';
  }

  return 'processing';
};

export const CLAIM_STATUS_COLOR_MAP: Record<ClaimStatusInternal, BadgeVariant> = {
  paid: 'green',
  processing: 'cream',
  ready: 'yellow',
};
